<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>热更新配置{{ formData.id > 0 ? '编辑' : '新增' }}</span>
        </div>
        <el-form ref="formData" :rules="rules" :model="formData" label-width="120px">
          <el-form-item label="版本" prop="gu_version">
            <el-input v-model="formData.gu_version" style="width: 400px" placeholder="版本" />
          </el-form-item>
          <el-form-item label="版本标题" prop="gu_title">
            <el-input v-model="formData.gu_title" style="width: 400px;" placeholder="版本标题" />
          </el-form-item>
          <el-form-item label="强制更新" prop="sid">
            <el-select v-model.number="formData.gu_force" style="width: 400px" placeholder="请选择">
              <el-option
                v-for="(item, index) in statusType"
                :key="index"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="更新url" prop="gu_updateurl">
            <el-form :inline="true">
              <el-form-item>
                <el-input v-model="formData.gu_updateurl" style="width: 350px;" placeholder="更新url" />
              </el-form-item>
              <el-form-item label="评论url" prop="gu_commonurl">
                <el-input v-model="formData.gu_commonurl" style="width: 350px;" placeholder="评论url" />
              </el-form-item>
              <el-form-item label="热更新地址" prop="gu_hotfix">
                <el-input v-model="formData.gu_hotfix" style="width: 350px;" placeholder="热更新地址" />
              </el-form-item>
            </el-form>
          </el-form-item>

          <el-form-item label="设备" prop="gu_device">
            <el-form :inline="true">
              <el-form-item>
                <el-select v-model="formData.gu_device" placeholder="请选择">
                  <el-option
                    v-for="item in deviceType"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
              <el-form-item label="更新奖励" prop="gu_isReward">
                <el-select v-model.number="formData.gu_isReward" placeholder="请选择">
                  <el-option
                    v-for="item in statusType"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>

              <el-form-item label="是否新的" prop="gh_news">
                <el-select v-model.number="formData.gh_news" placeholder="请选择">
                  <el-option
                    v-for="item in statusType"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>

              <el-form-item label="是否提醒" prop="gu_tips">
                <el-select v-model.number="formData.gu_tips" placeholder="请选择">
                  <el-option
                    v-for="item in statusType"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-form>

          </el-form-item>
          <el-form-item label="语言" prop="langs">
            <el-select v-model="formData.langs" style="width: 800px" multiple placeholder="请选择">
              <el-option
                v-for="(item, index) in lang"
                :key="index"
                :label="item"
                :value="index"
              />
            </el-select>
            <el-upload
              ref="upload"
              style="display: inline-block"
              class="upload-demo"
              :action="sys_app_logoAction"
              accept="xlsx"
              :limit="1"
              :on-success="(res)=>{return importUploadSuccess(res)}"
              :headers="headers"
            >
              <el-button style="margin-left: 10px" :loading="loading" icon="el-icon-upload2" type="primary">导入</el-button>
            </el-upload>
          </el-form-item>
          <el-form-item prop="title">
            <el-form :inline="true">
              <el-row v-for="(l, li) in formData.langs" :key="li">
                <el-form-item :label="lang[l]+': 标题'" style="margin-top: 8px;">
                  <el-input v-model="formData.title[l]" style="width: 480px;" :placeholder="lang[l]+': 标题'" />
                </el-form-item>
                <el-form-item label="内容" style="margin-top: 8px;">
                  <el-input
                    v-model="formData.body[l]"
                    placeholder="请输入内容"
                    style="width: 480px;"
                  />
                </el-form-item>
              </el-row>
            </el-form>
          </el-form-item>
          <el-form-item v-if="formData.gu_isReward === 1" label="奖励" prop="rewards">
            <el-form :inline="true">
              <el-row v-for="(pp,pi) in formData.gu_reward" :key="pi">
                <el-form-item label="道具" style="margin-top: 10px;">
                  <el-select v-model.number="pp.propsId" style="width: 130px;" placeholder="请选择">
                    <el-option
                      v-for="(item, index) in rewardType"
                      :key="index"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
                <el-form-item v-if="skinId.includes(pp.propsId)" style="margin-top: 10px;" label="皮肤">
                  <el-select v-if="pp.propsId === 62" v-model.number="pp.skin" placeholder="请选择" style="width: 120px">
                    <el-option
                      v-for="item in chessId"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>

                  <el-select v-if="pp.propsId === 19" v-model.number="pp.skin" placeholder="请选择" style="width: 120px">
                    <el-option
                      v-for="item in areaId"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>

                  <el-select v-if="pp.propsId === 67" v-model.number="pp.skin" placeholder="请选择" style="width: 120px">
                    <el-option
                      v-for="item in shield"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>

                  <el-select v-if="pp.propsId === 68" v-model.number="pp.skin" placeholder="请选择" style="width: 120px">
                    <el-option
                      v-for="item in sieve"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
                <el-form-item label="奖品数量" style="margin-top: 10px;">
                  <el-input v-model.number="pp.num" style="width: 130px;" placeholder="奖品数量" />
                </el-form-item>
                <el-form-item style="margin-top: 10px;" label="金币取值">
                  <el-select v-model.number="pp.rtype" :disabled="pp.propsId !== 14" placeholder="请选择" style="width: 120px">
                    <el-option
                      v-for="item in selectType"
                      :key="item.id"
                      :label="item.title"
                      :value="item.id"
                    />
                  </el-select>
                </el-form-item>
                <el-form-item style="margin-top: 10px;">
                  <el-button type="danger" @click="removeReward(pi)">删除</el-button>
                </el-form-item>
              </el-row>
              <el-form-item style="margin-top: 10px">
                <el-button type="primary" @click="addReward()">+</el-button>
              </el-form-item>
            </el-form>
          </el-form-item>
          <el-form-item label="备注" prop="remark">
            <el-input v-model="formData.remark" type="textarea" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">保存</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { getRewardType } from '@/api/config/slot'
import { searchUid } from '@/api/user/user_info'
import { getToken } from '@/utils/auth'
import { getGameUpdateList, importGameUpdateLang, updateGameUpdateCfg } from '@/api/config/game-update-cfg'
import { getChestCfgAll } from '@/api/config/chest-skin-cfg'
import { getAnimalAllList, getShieldsAllList, getSieveAllList } from '@/api/config/area-cfg'

export default {
  name: 'GameUpdateEdit',
  data() {
    return {
      skinId: [62, 19, 67, 68],
      chessId: [],
      shield: [],
      sieve: [],
      areaId: [],
      headers: { 'Authorization': 'Bearer ' + getToken() },
      sys_app_logoAction: process.env.VUE_APP_BASE_API + '/api/v1/public/uploadFile',
      queryParams: {
        pageIndex: 1,
        pageSize: 10
      },
      rewardType: [],
      total: 0,
      statusType: [
        { label: '是', value: 1 },
        { label: '否', value: 0 }
      ],
      deviceType: [
        { label: '安卓', value: 'android' },
        { label: '苹果', value: 'ios' }
      ],
      selectType: [
        {
          'id': 1,
          'title': '只取数量'
        },
        {
          'id': 2,
          'title': '等级取值'
        }
      ],
      users: [],
      lang: {
        'en': '英 文',
        'zh': '中 文',
        'tw': '繁 体',
        'fr': '法 语',
        'de': '德 语',
        'es': '西班牙',
        'pt': '葡萄牙',
        'th': '泰 语',
        'vn': '越 南',
        'no': '挪 威',
        'id': '印 尼'
      },
      loading: false,
      formData:
        {
          'id': 0,
          'gu_version': '',
          'gu_title': '',
          'gu_content': '',
          'gu_force': 0,
          'gu_updateurl': '',
          'gu_commonurl': '',
          'gu_hotfix': 0,
          'gu_device': 'android',
          'gu_langtitle': '',
          'gu_langcontent': '',
          'gu_isReward': 0,
          'gh_news': 0,
          'gu_tips': 0,
          'remark': '',
          'langs': [],
          'title': {},
          'body': {},
          'gu_reward': [{
            propsId: 14,
            skin: 0,
            num: 10,
            rtype: 2
          }]
        },
      rules: {}
    }
  },
  created() {
    this.getShieldsId()
    this.getSieveId()
    this.getChessId()
    this.getAreaId()
    const id = this.$route.query.id
    console.log(id)
    if (id > 0) {
      this.getTables(id)
    }
    this.getRewardTypeData()
  },
  methods: {
    getAreaId() {
      getChestCfgAll().then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            this.areaId.push({ 'label': res.data[i].name, 'value': parseInt(res.data[i].id) })
          }
        }
      })
    },
    getChessId() {
      getAnimalAllList().then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            this.chessId.push({ 'label': res.data[i].lang_key, 'value': parseInt(res.data[i].id) })
          }
        }
      })
    },
    getShieldsId() {
      getShieldsAllList().then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            this.shield.push({ 'label': res.data[i].lang_key, 'value': parseInt(res.data[i].id) })
          }
        }
      })
    },
    getSieveId() {
      getSieveAllList().then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            this.sieve.push({ 'label': res.data[i].lang_key, 'value': parseInt(res.data[i].id) })
          }
        }
      })
    },
    importUploadSuccess(response) {
      this.loading = true
      this.$refs.upload.clearFiles()
      importGameUpdateLang({ data: response.data.path }).then(res => {
        this.loading = false
        // eslint-disable-next-line eqeqeq
        if (res.code === 200) {
          this.formData.langs = res.data.lang
          this.formData.title = res.data.title
          this.formData.body = res.data.body
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getTables(id) {
      getGameUpdateList({ id: id }).then(res => {
        if (res.code === 200) {
          const data = res.data.list[0]
          this.$set(data, 'langs', [])
          this.$set(data, 'title', {})
          this.$set(data, 'body', {})
          console.log(this.formData)
          for (const i in data.gu_langtitle) {
            const val = data.gu_langtitle[i]
            data.title[i] = val
          }

          for (const i in data.gu_langcontent) {
            const val = data.gu_langcontent[i]
            data.body[i] = val
            data.langs.push(i)
          }
          this.formData = data
        } else {
          this.msgError(res.msg)
        }
      })
    }, onSubmit() {
      this.$refs['formData'].validate((valid) => {
        if (valid) {
          const regex = /^(\d+\.)+\d+$/

          if (!regex.test(this.formData.gu_version)) {
            this.msgError('版本格式有误')
            return
          }

          if (this.formData.langs.length > 0) {
            for (const i in this.formData.langs) {
              const _lang = this.formData.langs[i]
              const _title = this.formData.title[_lang]
              if (_title === '' || _title === undefined) {
                this.msgError('标题 ' + this.lang[_lang] + ' 不能为空')
                return
              }
            }

            for (const i in this.formData.langs) {
              const _lang = this.formData.langs[i]
              const _content = this.formData.body[_lang]
              if (_content === '' || _content === undefined) {
                this.msgError('内容 ' + this.lang[_lang] + ' 不能为空')
                return
              }
            }
          }

          this.formData.gu_langtitle = this.formData.title
          this.formData.gu_langcontent = this.formData.body
          const data = JSON.stringify(this.formData)

          updateGameUpdateCfg({ data: data }).then(res => {
            if (res.code === 200) {
              this.msgSuccess(res.msg)
              this.$router.push({ path: '/config/game-update/index' })
            } else {
              this.msgError(res.msg)
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    remoteMethod(query) {
      if (query !== '') {
        this.loading = true
        searchUid({ id: query }).then(res => {
          this.loading = false
          this.users = res.data
        })
      } else {
        this.users = []
      }
    },
    getRewardTypeData() {
      getRewardType().then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            this.rewardType.push({ 'label': res.data[i], 'value': parseInt(i) })
          }
        }
      })
    },
    addReward() {
      this.formData.gu_reward.push({
        propsId: 14,
        skin: 0,
        num: 1,
        rtype: 2
      })
    },
    removeReward(i) {
      this.formData.gu_reward = this.formData.gu_reward.filter((item, key) => {
        return i !== key
      })
    },
    dateFormat(d) {
      const dateObject = new Date(d)
      const year = dateObject.getFullYear()
      const month = String(dateObject.getMonth() + 1).padStart(2, '0')
      const day = String(dateObject.getDate()).padStart(2, '0')
      const hours = String(dateObject.getHours()).padStart(2, '0')
      const minutes = String(dateObject.getMinutes()).padStart(2, '0')
      const seconds = String(dateObject.getSeconds()).padStart(2, '0')

      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    }
  }
}
</script>

<style scoped>
</style>
